module.exports = __webpack_public_path__ + "static/media/consorcio-ara.f6a58a25.jpg";